(() => {
  angular
    .module('gm.common.directives')
    .directive('btgBoxInputSelector', btgBoxInputSelectorDirective);

  function btgBoxInputSelectorDirective() {
    'ngInject';

    return {
      restrict: 'E',
      require: 'ngModel',
      transclude: true,
      replace: true,
      scope: {
        options: '=',
        activeItem: '=?',
        label: '@',
        tooltip: '@',
        tooltipType: '@',
        metaLeft: '@',
        placeholder: '@'
      },
      templateUrl: 'modules/common/directives/forms/box-input-selector/box-input-selector.html',
      link(scope, _element, _attrs, ctrl) {
        scope.value = null;

        ctrl.$render = () => {
          scope.value = ctrl.$viewValue;
        };

        scope.$watch('value', (value) => {
          ctrl.$setViewValue(value);

          if (!scope.activeItem) {
            const items = scope.options.filter((o) => {
              const currentName = (angular.isDefined(o.value) ? o.value : o.name).toString();

              return currentName === value;
            });

            if (items.length === 1) {
              scope.activeItem = items[0];
            }
          }
        });

        scope.selectItem = (item) => {
          scope.value = angular.isDefined(item.value) ? item.value : item.name;
          scope.activeItem = item;
        };

        scope.onInputChange = () => {
          scope.activeItem = null;
        };
      }
    };
  }
})();
